import { render } from "./IconCodec.vue?vue&type=template&id=69366b77"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconCodec.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "69366b77"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('69366b77', __exports__)) {
    api.reload('69366b77', __exports__)
  }
  
  module.hot.accept("./IconCodec.vue?vue&type=template&id=69366b77", () => {
    api.rerender('69366b77', render)
  })

}


export default __exports__